module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetMedium@2x.2da243e.jpg";